import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { useCallback } from 'react';

import { RequestOnlineBiddingButton } from '@/components/ItemBidding/RequestOnlineBiddingButton';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { getCatalogIsCatalogOnly, getCatalogIsTimedPlus } from '@/redux/modules/catalog/catalogs/catalog.selectors';
import { getCatalogDetailExternalUrl } from '@/redux/modules/catalog/detail/catalogDetail.selectors';
import { submitRegisterForCatalog, SubmitRegisterForCatalogParams } from '@/redux/modules/registerForCatalog';

import { TimedOrLiveAuctionStatusExperiment } from './TimedOrLiveAuctionStatusExperiment';
import { TimedPlusAuctionStatusExperiment } from './TimedPlusAuctionStatusExperiment';

type Props = {
    catalogId: number;
    forceIsLive?: boolean;
};

export const CatalogBannerActions = ({ catalogId, forceIsLive = false }: Props) => {
    const dispatch = useAppDispatch();

    const isCatalogOnly = useAppSelector((state) => getCatalogIsCatalogOnly(state, catalogId));
    const externalUrl = useAppSelector((state) => getCatalogDetailExternalUrl(state, catalogId));
    const isTimedPlus = useAppSelector((state) => getCatalogIsTimedPlus(state, catalogId));

    const registerForCatalog = useCallback(
        ({ catalogId, itemId }: SubmitRegisterForCatalogParams) =>
            dispatch(submitRegisterForCatalog({ catalogId, itemId })),
        [dispatch]
    );

    if (isCatalogOnly) {
        return (
            <RequestOnlineBiddingButton
                catalogId={catalogId}
                className="max-h-[42px] w-full"
                showPartnerSiteWarning={false}
                submitRegisterForCatalog={registerForCatalog}
                text={Boolean(externalUrl) && <FormattedMessage id="registerOnPartnersSiteExperiment" />}
            />
        );
    }

    if (isTimedPlus) {
        return (
            <TimedPlusAuctionStatusExperiment
                catalogId={catalogId}
                className="w-full max-w-[384px]"
            />
        );
    }

    return (
        <TimedOrLiveAuctionStatusExperiment
            catalogId={catalogId}
            className="w-full max-w-[384px]"
            forceIsLive={forceIsLive}
        />
    );
};
